import { ReactElement, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { baseServerSideProps } from '../../shared/utils/base-server-side-props'
import GoogleAnalytics from 'shared/components/google-analytics'
import { DomainAssetsInterface } from 'shared/types/domain'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { getPublicLayout } from '../../modules/templates/layout'
import TemplatesCategories from 'modules/templates/components/templates-categories'
import TemplatesList from 'modules/templates/components/templates-list'
import { TemplatesFilterInterface } from 'modules/templates/types/templates-filter-interface'
import { defaultBrandSettings } from 'modules/white-label/constants/brand-settings'

const defaultFilter: TemplatesFilterInterface = {
  category: null,
}

const Templates = () => {
  const { locale } = useRouter()

  const [filter, setFilter] = useState<TemplatesFilterInterface>(defaultFilter)

  useEffect(() => {
    setFilter({ category: null })
  }, [locale])

  const onChangeCategory = (category: number | null) => setFilter(prev => ({ ...prev, category }))

  return (
    <>
      <div className="grid grid-cols-1 grid-rows-1 justify-center gap-8 lg:gap-20">
        <div className="flex flex-col gap-5 lg:flex-row lg:gap-11">
          <TemplatesCategories filter={filter} onChangeCategory={onChangeCategory} />
          <TemplatesList onChangeCategory={onChangeCategory} filter={filter} />
        </div>
      </div>
      <GoogleAnalytics />
    </>
  )
}

export const getServerSideProps = withDomainAssets(
  baseServerSideProps,
  defaultBrandSettings.dashboardHostname,
)

Templates.getLayout = (page: ReactElement, props: { domainAssets?: DomainAssetsInterface }) =>
  getPublicLayout(page, {
    pageTitle: 'public.templates.templates_library',
    domainAssets: props.domainAssets,
  })

export default Templates
